import { SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION } from 'constants';
import React, { useState } from 'react'
import GameManager from '../../../../../GameManager';
import Tools from '../../../../../Misc/Tools';
import { JSXUIDebugTemplate, JSXUIData } from '../../../../../UI/JsxUiManager';
import { UI } from '../../../../../UI/UiManager';
import { VideoSegmentItem, SingleVideoSegmentItem } from '../../../../../VideoSegment/VideoSegmentItem';
import { VideoSegmentManager } from '../../../../../VideoSegment/VideoSegmentManager';
import VideoEnvironment from '../../../../Environments/React/VideoEnvironment';
import CoreGeneralButton from '../../core-general-button';
import CoreLandingPage from '../../core-landing-page';
import CoreDebugAnimationsWindow from './core-debug-animations-window';
import CoreDebugComponentsWindow from './core-debug-components-window';
import CoreDebugLandingPageWindow from './core-debug-landing-page-window';

import "./core-debug-ui.css"
import CoreDebugUIsWindow from './core-debug-uis-window';
import CoreDebugVideoSegmentsWindow from './core-debug-video-segments-window';

enum DebugWindow {
	None,
	Main,
	VideoSegments,
	PlayingVideo,
	UIs,
	Aniamtions,
	Components,
	LandingPage,
	DebugUI
}

const CoreDebugUI = (props: CoreDebugUIConfig) => {
	const [currentWindow, setCurrentWindow] = useState(props.debugScenario ? DebugWindow.Main : DebugWindow.None);
	const [windowBackground, setWindowBackground] = useState(props.debugScenario);
	const [forceUpdate, setForceUpdate] = useState(false);
	const gameManager: GameManager =(window as any)['core-gm'];

	const onBackToMainProjectClicked = () => {
		window.close();
	}

	const onDebugClicked = () => {
		window.open('/?w=core-debug', '_blank');
	}

	const onMainWindowVideoSegmentsClicked = () => {
		setWindowBackground(true);
		setCurrentWindow(DebugWindow.VideoSegments);
	}

	const onMainWindowUIsClicked = () => {
		setWindowBackground(true);
		setCurrentWindow(DebugWindow.UIs);
	}

	const onMainWindowAnimationsClicked = () => {
		setWindowBackground(true);
		setCurrentWindow(DebugWindow.Aniamtions);
	}
	const onMainWindowComponentsClicked = () => {
		setWindowBackground(false);
		setCurrentWindow(DebugWindow.Components);
	}
	const onMainWindowLandingPageClicked = () => {
		setWindowBackground(true);
		setCurrentWindow(DebugWindow.LandingPage);
	}

	const onBackToMainWindowClicked = () => {
		setWindowBackground(true);
		setCurrentWindow(DebugWindow.Main);
	}

	const onStopPlaybackButtonClicked = () => {
		setWindowBackground(true);
		setCurrentWindow(DebugWindow.VideoSegments);

		
	}

	const onUISpawned = () => {
		setWindowBackground(false);
		setCurrentWindow(DebugWindow.DebugUI);
	}

	const onAnimationTestEnvironmentSpawned = () => {
		setWindowBackground(false);
		setCurrentWindow(DebugWindow.DebugUI);
	}

	const generateMockDataFromTemplate = (template: any) => {
		const loremIpsum = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.';

		const evaluateString = (propName: string) => {
			if(propName.toLocaleLowerCase().indexOf('title') !== -1) {
				//title
				return 'Sample title';
			} else if(propName.toLocaleLowerCase().indexOf('html') !== -1) {
				//html
				return '<p class="">' + loremIpsum + '</p>';
			} else {
				//normal paragraph
				return loremIpsum;
			}
		}
		for(var prop in template) {
			switch(typeof template[prop]) {
				case 'string':
					template[prop] = evaluateString(prop);
					break;
				case 'object':
					template[prop] = generateMockDataFromTemplate(template[prop]);
					break;
				case 'number':
					template[prop] = Math.floor(Math.random() * 101);
					break;
				case 'boolean':
					template[prop] = Math.floor(Math.random() * 2) === 0 ? false : true;
					break;
				default:
					console.warn('UI debug warning: ignoring property ' + prop)
					break;
			}
		}
		return template;
	}

	const onCloseDebugUIClicked = () => {
		setWindowBackground(true);
		setCurrentWindow(DebugWindow.UIs);

		gameManager.UiManager.destroyAllInstances();
		for(var indx = 0; indx < gameManager.UiManager._uis.length; indx++) {
			Tools.forceRerenderUI(gameManager.UiManager._uis[indx].name);
		}
	}

	const renderCurrentWindow = () => {
		switch(currentWindow) {
			case DebugWindow.Main:
				return renderMainWindow();
			case DebugWindow.VideoSegments:
				return renderVideoSegmentWindow();
			case DebugWindow.PlayingVideo:
				return renderPlayingVideoWindow();
			case DebugWindow.UIs:
				return renderUIsWindow();
			case DebugWindow.Aniamtions:
				return renderAnimationsWindow();
			case DebugWindow.Components:
				return renderComponentsWindow();
			case DebugWindow.LandingPage:
				return renderLandingPageWindow();
			case DebugWindow.DebugUI:
				return renderDebugUI();
		}
		return null;
	}

	const renderMainWindow = () => {
		return (
			<div className='core-debug-ui-main-window core-debug-ui-general-window'>
				<div className='core-debug-ui-main-window-bttn'>
					<CoreGeneralButton width= '100%'
						height= '100%'
						onClick= {onMainWindowVideoSegmentsClicked}
						onRenderContent= {() => {
							return (
								<p className='center-element'>{'Video Segments'}</p>
							)
						}}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'Video Segments'}></CoreGeneralButton>
				</div>

				<div className='core-debug-ui-main-window-bttn'>
					<CoreGeneralButton width= '100%'
						height= '100%'
						onClick= {onMainWindowUIsClicked}
						onRenderContent= {() => {
							return (
								<p className='center-element'>{'UIs'}</p>
							)
						}}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'UIs'}></CoreGeneralButton>
				</div>
				<div className='core-debug-animations-main-window-bttn'>
					<CoreGeneralButton width= '100%'
						height= '100%'
						onClick= {onMainWindowAnimationsClicked}
						onRenderContent= {() => {
							return (
								<p className='center-element'>{'Animations'}</p>
							)
						}}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'Animations'}></CoreGeneralButton>
				</div>
				<div className='core-debug-animations-main-window-bttn'>
					<CoreGeneralButton width= '100%'
						height= '100%'
						onClick= {onMainWindowComponentsClicked}
						onRenderContent= {() => {
							return (
								<p className='center-element'>{'Components'}</p>
							)
						}}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'Components'}></CoreGeneralButton>
				</div>
				<div className='core-debug-animations-main-window-bttn'>
					<CoreGeneralButton width= '100%'
						height= '100%'
						onClick= {onMainWindowLandingPageClicked}
						onRenderContent= {() => {
							return (
								<p className='center-element'>{'Landing Page'}</p>
							)
						}}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'Landing Page'}></CoreGeneralButton>
				</div>
			</div>
		);
	}

	const renderVideoSegmentWindow = () => {
		return (
			<CoreDebugVideoSegmentsWindow showWindowBackground={windowBackground}
									gameManager={gameManager}
									onBackToMainWindowClicked={onBackToMainWindowClicked}
									setForceUpdate={() => setForceUpdate(!forceUpdate)}
									onVideoSegmentStarted={() => {
										setWindowBackground(false);
										setCurrentWindow(DebugWindow.None);
									}}
									onVideoSegmentPlaying={() => {
										setCurrentWindow(DebugWindow.PlayingVideo);
									}}
									onVideoSegmentStopped={() => {
										setWindowBackground(true);
										setCurrentWindow(DebugWindow.VideoSegments);
									}}
									videoSegmentManager={props.videoSegmentManager}></CoreDebugVideoSegmentsWindow>
		);
	}

	const renderDebugUI = () => {
		return (
			<div>
				<div className='core-debug-ui-stop-video-bttn'>
					<CoreGeneralButton width= '100%'
						height= '100%'
						style={{backgroundColor: 'red'}}
						onClick= {onCloseDebugUIClicked}
						onRenderContent= {() => {
							return (
								<div className='center-element' style={{
									width: '40px',
									height: '40px'
								}}><p className='' style={{
									color: 'white',
									textAlign: 'center'
								}}>X</p></div>
							)
						}}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'Stop Playback'}></CoreGeneralButton>
				</div>

				<video src='' />
			</div>
		);
	}

	const renderPlayingVideoWindow = () => {
		return (
			<div>
				<div className='core-debug-ui-stop-video-bttn'>
					<CoreGeneralButton width= '100%'
						height= '100%'
						style={{backgroundColor: 'red'}}
						onClick= {onStopPlaybackButtonClicked}
						onRenderContent= {() => {
							return (
								<div className='center-element' style={{
									width: '40px',
									height: '40px',
									backgroundColor: 'white'
								}}></div>
							)
						}}
						isSelected= {false}
						isDisabled={false}
						ariaLabel= {'Stop Playback'}></CoreGeneralButton>
				</div>

				<video src='' />
			</div>
		);
	}

	const renderUIsWindow = () => {
		return (
			<CoreDebugUIsWindow showWindowBackground={windowBackground}
									gameManager={gameManager}
									onBackToMainWindowClicked={onBackToMainWindowClicked}
									setForceUpdate={() => setForceUpdate(!forceUpdate)}
									onUISpawned={onUISpawned}></CoreDebugUIsWindow>
		);
	}

	const renderAnimationsWindow = () => {

		return (
			<CoreDebugAnimationsWindow showWindowBackground={windowBackground}
									gameManager={gameManager}
									onBackToMainWindowClicked={onBackToMainWindowClicked}
									setForceUpdate={() => setForceUpdate(!forceUpdate)}
									onTestEnvironmentSpawned={onAnimationTestEnvironmentSpawned}></CoreDebugAnimationsWindow>
		);
	}

	const renderComponentsWindow = () => {

		return (
			<CoreDebugComponentsWindow showWindowBackground={windowBackground}
									gameManager={gameManager}
									onBackToMainWindowClicked={onBackToMainWindowClicked}
									setForceUpdate={() => setForceUpdate(!forceUpdate)}
									onTestEnvironmentSpawned={onAnimationTestEnvironmentSpawned}></CoreDebugComponentsWindow>
		);
	}

	const renderLandingPageWindow = () => {
		return (
			<CoreDebugLandingPageWindow showWindowBackground={windowBackground}
									gameManager={gameManager}
									onBackToMainWindowClicked={onBackToMainWindowClicked}
									setForceUpdate={() => setForceUpdate(!forceUpdate)}
									onSpawned={() => {
										setWindowBackground(false);
										setCurrentWindow(DebugWindow.DebugUI);
									}}></CoreDebugLandingPageWindow>
		);
	}

	return (
		<div className="core-debug-ui-container" style={{
			backgroundColor: windowBackground ? 'rgba(0,0,0,0.5)' : 'transparent'
		}}>
			<div>
				{renderCurrentWindow()}
			</div>
			<div className='core-debug-ui-debug-bttn'>
				<CoreGeneralButton width= '100%'
					height= '100%'
					onClick= {props.debugScenario ? onBackToMainProjectClicked : onDebugClicked}
					onRenderContent= {() => {
						return (
							<p className='center-element'>{ props.debugScenario ? 'Back to Main Project' : 'Debug Project'}</p>
						)
					}}
					isSelected= {false}
					isDisabled={false}
					ariaLabel= {props.debugScenario ? 'Back to Main Project' : 'Debug Project'}></CoreGeneralButton>
			</div>
		</div>
	);
};

export interface CoreDebugUIConfig {
	debugScenario: boolean; //true if we are inside our sandbox scenario
	videoSegmentManager: VideoSegmentManager;
}

export default CoreDebugUI;